module.exports = __webpack_public_path__ + "img/wechat.2d58a229.svg";